import { axiosInstance } from '../axios';

const API_URL = '/api/parts';

class PartsService {

  async addPart(part) {
    return await axiosInstance.put(API_URL + '/part', part);
  }


  async findPartsByNameOrIdentification(searchTerm, supplierId){

    const params = new URLSearchParams();

    if (searchTerm !== null) {
      params.append('searchTerm', searchTerm);
    }
    if (supplierId){
     params.append('supplierId', supplierId);
    }

    const config = {
      params: params,
    };
    return axiosInstance.get(`${API_URL}/findParts`, config);
  }
}

export default new PartsService();
